import React, { type FC, type ReactNode, useEffect } from 'react';
import type { WidgetProps } from '@wix/yoshi-flow-editor';
import type { ControllerProps } from '@appTypes';
import { BiLoggerContext } from '@services/BiLogger';
import { ErrorBoundary } from '@components/ErrorBoundary';
import { AppContext } from '@components/AppContext';
import { ToastContext } from '@components/Toast';
import { ModalContext } from '@components/Modal';
import { App, GeneralError } from './App';

export type WidgetComponentProps = WidgetProps<ControllerProps> & {
  children: ReactNode;
};

export const WidgetProviders: FC<WidgetComponentProps> = (props) => {
  const {
    biLogger,
    appParams,
    currentToast,
    toastActions,
    currentModal,
    modalActions,
    host,
    children,
  } = props;
  const { blockScroll, unblockScroll, viewMode, formFactor: deviceType } = host;

  useEffect(() => {
    biLogger?.reportPageLoaded();
  }, [biLogger]);

  return (
    <AppContext.Provider value={{ ...appParams, viewMode, deviceType }}>
      <BiLoggerContext.Provider value={{ biLogger }}>
        <ModalContext.Provider
          value={{ blockScroll, unblockScroll, currentModal, ...modalActions }}
        >
          <ToastContext.Provider value={{ currentToast, ...toastActions }}>
            {children}
          </ToastContext.Provider>
        </ModalContext.Provider>
      </BiLoggerContext.Provider>
    </AppContext.Provider>
  );
};

const Widget: FC<WidgetComponentProps> = ({ hasInitError, ...props }) => (
  <ErrorBoundary fallback={<GeneralError />} forceRender={hasInitError}>
    <WidgetProviders {...props}>
      <App {...props} />
    </WidgetProviders>
  </ErrorBoundary>
);

export default Widget;
